/**
 * Os temas que cada pessoa pode escolher — o `AppPalette` de
 * `lib/core/theme/app_palette.dart`.
 *
 * Lá um tema é a Dusk Petal girada no círculo de cores, e a amostra do seletor
 * é o `#C2185B` depois do giro. Aqui a amostra vem escrita: girar de novo em
 * JavaScript daria a mesma cor por um caminho mais comprido, e o número escrito
 * é conferível contra o Flutter (foi de lá que ele saiu, medido).
 *
 * O giro e a saturação continuam anotados porque são eles que explicam a
 * amostra — e porque é por eles que se percebe a esquisitice honesta desta
 * lista: o `#C2185B` já está em 336 graus, então somar 95 não dá azul, dá um
 * verde-amarelo. Os nomes prometem uma cor e as amostras mostram outra. Isso é
 * assim no Flutter, e o site copia o Flutter.
 */

export interface Paleta {
  id: string;
  nome: string;
  descricao: string;
  /** Quanto girar o matiz, em graus. */
  giro: number;
  /** Multiplicador de saturação, para um tema mais lavado ou mais vivo. */
  saturacao: number;
  /** A cor que representa o tema no seletor. `#C2185B` depois do giro. */
  amostra: string;
}

export const PALETAS: readonly Paleta[] = [
  {
    id: 'rosa',
    nome: 'Rosa Crepúsculo',
    descricao: 'o original, rosa sobre violeta',
    giro: 0,
    saturacao: 1,
    amostra: '#C2185B',
  },
  {
    id: 'lilas',
    nome: 'Lilás Noturno',
    descricao: 'violeta mais fundo, quase uva',
    giro: 40,
    saturacao: 1,
    amostra: '#C24618',
  },
  {
    id: 'azul',
    nome: 'Azul de Meia-noite',
    descricao: 'frio e calmo, azul sobre índigo',
    giro: 95,
    saturacao: 1,
    amostra: '#A2C218',
  },
  {
    id: 'verde',
    nome: 'Verde Musgo',
    descricao: 'esmeralda sobre mata fechada',
    giro: 160,
    saturacao: 1,
    amostra: '#18C246',
  },
  {
    id: 'ambar',
    nome: 'Âmbar de Vela',
    descricao: 'dourado quente, luz de jantar',
    giro: 225,
    saturacao: 1,
    amostra: '#1886C2',
  },
  {
    id: 'coral',
    nome: 'Coral de Verão',
    descricao: 'laranja vivo sobre terracota',
    giro: 260,
    saturacao: 1.1,
    amostra: '#0F1BCB',
  },
];

/** `AppPalette.porId`: o que não estiver na lista vira o primeiro. */
export function paletaPorId(id?: string | null): Paleta {
  return PALETAS.find((p) => p.id === id) ?? PALETAS[0];
}
